/* eslint-disable react/prop-types */
import { Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import { NavLink, useLocation } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { BsBook } from "react-icons/bs";
import { Form, Select, SelectItem } from "@heroui/react";
import { PiBookOpenText, PiChalkboardTeacher } from "react-icons/pi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { FaRegClipboard, FaWpforms } from "react-icons/fa6";
import { IoBookOutline } from "react-icons/io5";

import { CiBellOn } from "react-icons/ci";
import { useGetOrganizationDataQuery } from "../../redux/apis/courseApi";
import { NewspaperOutlined } from "@mui/icons-material";
import { MessageCircleMore } from "lucide-react";
const AdminSidebar = ({ collapsed }) => {
  const { pathname } = useLocation();
  const mainPath = pathname.split("/")[2];
  const defaultRoute =
    mainPath?.slice(0).charAt(0).toUpperCase() + mainPath?.slice(1);

  const organizations = [
    { key: "aap", label: "AAPathsahla" },
    { key: "udvash", label: "Udvash" },
    { key: "unmesh", label: "Unmesh" },
  ];
  const { data: organizationData } = useGetOrganizationDataQuery();
  const sidebarItems = [
    {
      key: "Dashboard",
      icon: <RxDashboard size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/dashboard" className="text-base font-semibold">
          Dashboard
        </NavLink>
      ),
    },
    {
      key: "Courses",
      icon: <BsBook size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/courses" className="text-base font-semibold">
          Courses
        </NavLink>
      ),
    },
    {
      key: "form",
      icon: <FaWpforms size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/form" className="text-base font-semibold">
          Form
        </NavLink>
      ),
    },
    {
      key: "sms",
      icon: <MessageCircleMore size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/sms" className="text-base font-semibold">
          SMS History
        </NavLink>
      ),
    },
    {
      key: "pre-booking",
      icon: <FaWpforms size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/pre-booking" className="text-base font-semibold">
          Pre-Booking
        </NavLink>
      ),
    },

    {
      key: "mentor-activity",
      icon: <PiChalkboardTeacher size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to="/admin/mentor-activity"
          className="text-base font-semibold"
        >
          Mentor Activity
        </NavLink>
      ),
    },

    // {
    //   key: "Course-Content",
    //   icon: <PiBookOpenText size={20} className="flex-shrink-0" />,
    //   label: (
    //     <NavLink to="/admin/course-content" className="text-base font-semibold">
    //       Course Content
    //     </NavLink>
    //   ),
    // },
    {
      key: "Classes",
      icon: <FaChalkboardTeacher size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/classes" className="text-base font-semibold">
          Classes
        </NavLink>
      ),
    },
    {
      key: "Exams",
      icon: <FaRegClipboard size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/exams" className="text-base font-semibold">
          Exams
        </NavLink>
      ),
    },
    {
      key: "Edit-Profile",
      icon: <FaRegClipboard size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/edit-profile" className="text-base font-semibold">
          Edit Profile
        </NavLink>
      ),
    },
    {
      key: "admission-news",
      icon: <NewspaperOutlined size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/admission-news" className="text-base font-semibold">
          Admission News
        </NavLink>
      ),
    },
    {
      key: "add-routine",
      icon: <IoBookOutline size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/add-routine" className="text-base font-semibold">
          Add Routine
        </NavLink>
      ),
    },
    organizationData?.is_notification && {
      key: "Notifications",
      icon: <CiBellOn size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/notifications" className="text-base font-semibold">
          Notifications
        </NavLink>
      ),
    },
    organizationData?.is_result && {
      key: "add-results",
      icon: <PiBookOpenText size={20} className="flex-shrink-0" />,
      label: (
        <NavLink to="/admin/add-results" className="text-base font-semibold">
          Add Result
        </NavLink>
      ),
    },
    organizationData?.is_banner_notification && {
      key: "banner-notifications",
      icon: <CiBellOn size={20} className="flex-shrink-0" />,
      label: (
        <NavLink
          to="/admin/banner-notifications"
          className="text-base font-semibold"
        >
          Banner Notification
        </NavLink>
      ),
    },
    // {
    //   key: "Database",
    //   icon: <FaDatabase size={20} className="flex-shrink-0" />,
    //   label: (
    //     <NavLink to="/admin/myDatabase" className="text-base font-semibold">
    //       My Database
    //     </NavLink>
    //   ),
    // },
  ];
  return (
    <Sider
      theme="light"
      trigger={null}
      collapsible
      collapsed={collapsed}
      width="250px"
      className="h-[calc(100vh-64px)]"
    >
      <Menu
        mode="inline"
        defaultSelectedKeys={[defaultRoute]}
        items={sidebarItems}
        className="text-base font-semibold h-[calc(100%-64px)]"
      />
    </Sider>
  );
};

export default AdminSidebar;
